import React from "react";

interface IFormDropDownOptions {
  value: string | number;
  label: string;
}

interface IFormDropDownProps {
  label: string;
  id: string;
  value?: string | number;
  required?: boolean;
  disabled?: boolean;
  options: IFormDropDownOptions[];
  error?: string | undefined;
  onChange: (id: string, value: string) => void;
  hint?: string;
  hideLabel?: boolean;
}

function FormDropDown({
  label,
  id,
  required,
  disabled,
  options,
  value,
  error,
  onChange,
  hint = "",
  hideLabel = false,
}: IFormDropDownProps) {
  const css: string = disabled ? "form-input-disabled" : "form-input";
  return (
    <div>
      {!hideLabel && (
        <label htmlFor={id} className="form-label">
          {label}
          {required && <>*</>}
        </label>
      )}
      <select
        name={id}
        id={id}
        value={value}
        className={css}
        required={required}
        onChange={(e) => onChange(id, e.target.value)}
        disabled={disabled}
      >
        {options.map((option) => {
          return (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
      {hint && <div className="form-hint">{hint}</div>}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormDropDown;
